import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color", "semanticColor", "paddingBottom", "variant", "className", "as", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/** This component has been marked as a server component in /scripts/use-client..mjs **/
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { ecx } from "../../utils.mjs";
import { colorClass, isSpacer, paddingBottomClass, textClass } from "../../styles/layout-theme.mjs";
var variantOptions = ['headlineLarge', 'headlineMedium', 'titleLarge', 'titleMedium', 'titleSmall', 'titleExtraSmall', 'bodyMedium', 'bodyMediumBold', 'bodySmall', 'bodySmallBold', 'marginal', 'marginalBold', 'marginalSmall', 'marginalSmallBold'];
/**
 * Text is a component used to create consistently styled text that works in any language, script, or large text mode.
 * This component replaces the deprecated [Type](https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-type--docs) component.
 *
 * **It requires global css variables to work properly**. You must follow the [setup instructions](https://encore.spotify.net/components/text?format=web.mjs#setup-2) before using this component.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-text--docs) |
 * [Encore site](https://encore.spotify.net/web/components/text) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Text)
 */
export var Text = /*#__PURE__*/React.forwardRef(function TextComponent(_ref, ref) {
  var color = _ref.color,
    semanticColor = _ref.semanticColor,
    paddingBottom = _ref.paddingBottom,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'bodyMedium' : _ref$variant,
    className = _ref.className,
    as = _ref.as,
    style = _ref.style,
    props = _objectWithoutProperties(_ref, _excluded);
  var Element = as ? as : 'span';
  var inlineStyles = !isSpacer(paddingBottom) ? _objectSpread({
    paddingBlockEnd: paddingBottom
  }, style) : style;
  return /*#__PURE__*/React.createElement(Element, Object.assign({
    className: ecx(['text', textClass(variant), semanticColor && colorClass(semanticColor), isSpacer(paddingBottom) && paddingBottomClass(paddingBottom)], className),
    ref: ref,
    "data-encore-id": ENCORE_DATA_IDS.Text,
    style: _objectSpread({}, inlineStyles)
  }, props));
});